import { useMemo } from "react";

import { isFuture } from "date-fns";
import { useAtomValue } from "jotai";
import { EBenefitContentTab } from "library/types";
import { benefitContentTabAtom } from "store/UIBenefitsPage";

import { useBenefitsData } from "hooks/useBenefitsData";

export function useFilterCategoryOptions() {
  const { eligibleFilteredData, enrolledFilteredData } = useBenefitsData();
  const selectedBenefitTab = useAtomValue(benefitContentTabAtom);

  const categoryOptions = useMemo(() => {
    const result = {};
    let arrayData;

    switch (selectedBenefitTab) {
      case EBenefitContentTab.eligible:
        arrayData = eligibleFilteredData;
        break;
      case EBenefitContentTab.enrolled:
        arrayData = enrolledFilteredData;
        break;
      case EBenefitContentTab.all:
      case EBenefitContentTab.expired:
        arrayData = [...eligibleFilteredData, ...enrolledFilteredData];
        break;
      default:
        arrayData = enrolledFilteredData;
    }

    [...arrayData].forEach((benefitPackage) => {
      if (benefitPackage?.dateOfCancellation) {
        if (!isFuture(new Date(benefitPackage?.dateOfCancellation))) {
          return;
        }
      }

      const categoryTag = benefitPackage?.benefitCategoryTag;
      const categoryName = benefitPackage?.benefitCategoryName || "";

      if (!categoryTag) return;

      if (!result[categoryName]) {
        result[categoryName] = categoryTag;
      }
    });

    return Object.keys(result).map((item) => {
      return {
        name: item,
        id: result[item],
      };
    });
  }, [enrolledFilteredData]);

  return categoryOptions;
}
